// ISO Datetime based on current hour without minutes and soconds
export const hourOnlyISODatetime = (val) => {
  const now = new Date(Date.now());
  return new Date(new Date((now.getTime() - val * 86400000)).setHours(now.getHours(), 0, 0, 0)).toISOString();
};
